import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Input,
  Col,
  Row,
  Spin,
  Form,
  Button,
  Modal,
  DatePicker,
} from 'antd';
import FormSubmitControls from 'components/FormSubmitControls';
import { getRecibo, patchRecibo } from 'api/recaudacion/recibos';
import getFormattedValues, { DATETIME_FRONTEND_FORMAT, formatReceived } from 'utils/formatValues';
import { onError } from 'utils/handlers';
import { getMotivosDeReintegro } from 'api/recaudacion/motivosDeReintego';
import Select from 'components/Select';
import { CloseCircleOutlined } from '@ant-design/icons';

const ModalReintegros = ({
  visible,
  setVisible,
  reciboId,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [motivos, setMotivos] = useState([]);

  useEffect(() => {
    const fetch = async () => {
      const _motivos = await getMotivosDeReintegro();
      const recibo = await getRecibo(reciboId);
      setMotivos(_motivos);
      if (recibo) form.setFieldsValue(formatReceived(recibo));
    };
    fetch();
  }, [visible]);

  const onCancel = () => {
    setVisible(false);
    form.resetFields();
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const formattedValues = getFormattedValues(values, {}, ['fecha_de_reintegro']);
      const key = reciboId;
      const edited = await patchRecibo(key, formattedValues);
      if (edited) {
        setVisible(false);
        form.resetFields();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onDelete = async () => {
    try {
      setLoading(true);
      const valuesToNull = {
        motivo_de_reintegro: null,
        usuario_reintegro: null,
        observaciones_de_reintegro: null,
        fecha_de_reintegro: null,
      };
      const key = reciboId;
      const edited = await patchRecibo(key, valuesToNull);
      if (edited) {
        setVisible(false);
        form.resetFields();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const rules = { required: [{ required: true }] };

  return (
    <Modal
      open={visible}
      closable={false}
      footer={null}
      maskClosable={!loading}
      keyboard={!loading}
      title={(

        <FormSubmitControls
          label="Reintegro"
          onFinish={onFinish}
          onCancel={onCancel}
          customAction={() => onDelete()}
          customActionText="Eliminar"
          allowCustomAction
          customActionIcon={<CloseCircleOutlined />}
        />
      )}
      onCancel={onCancel}
      forceRender
      centered
    >
      <Spin
        tip="Cargando..."
        spinning={loading}
      >
        <Form
          layout="vertical"
          form={form}
          scrollToFirstError
          onFinish={() => onFinish()}
        >
          <Row gutter={10}>
            <Col span={24}>
              <Form.Item
                label="Motivo de Reintegro"
                name="motivo_de_reintegro"
                rules={rules.required}
              >
                <Select dataSource={motivos} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="fecha_de_reintegro"
                label="Fecha de Reintegro"
                rules={rules.required}
              >
                <DatePicker
                  placeholder=""
                  format={DATETIME_FRONTEND_FORMAT}
                  showTime
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="observaciones_de_reintegro"
                label="Observaciones"
              >
                <Input.TextArea allowClear autoSize={{ minRows: 3, maxRows: 5 }} />
              </Form.Item>
            </Col>
            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Row>
        </Form>
      </Spin>
    </Modal>
  );
};

ModalReintegros.propTypes = {
  setVisible: PropTypes.func.isRequired,
  visible: PropTypes.bool,
  reciboId: PropTypes.number,
};
ModalReintegros.defaultProps = {
  reciboId: [],
  visible: false,
};

export default ModalReintegros;
